import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../core/services/authentication.service';
@Injectable()
export class IsOpportunityGuard implements CanActivate {
  constructor(private authService: AuthenticationService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.authService.IsAuthenticated().then((auth: boolean) => {
      if (auth) {
        const currentUrlState = state.url;
        let returnFlag = true;
        if (currentUrlState.includes('user')) {
          const opp = this.authService.getCurrentOpportunityId();
          if (!opp) {
            returnFlag = false;
          }
        } else if (currentUrlState.includes('life-insurance')) {
          const opp = this.authService.getCurrentLifeInsuranceOpportunityId();

          if (!opp) {
            returnFlag = false;
          }
        } else if (currentUrlState.includes('financial-planning')) {
          const opp =
            this.authService.getCurrentFinancialPlanningOpportunityId();
          if (!opp) {
            returnFlag = false;
          }
        } else if (currentUrlState.includes('superannuation')) {
          const opp = this.authService.getCurrentSuperOpportunityId();
          if (!opp) {
            returnFlag = false;
          }
        } else if (currentUrlState.includes('managed-account')) {
          const opp = this.authService.getCurrentInvestmentOpportunityId();
          if (!opp) {
            returnFlag = false;
          }
        } else if (currentUrlState.includes('general-insurance')) {
          const opp =
            this.authService.getCurrentGeneralInsuranceOpportunityId();
          if (!opp) {
            returnFlag = false;
          }
        } else if (currentUrlState.includes('estate-planning')) {
          const opp = this.authService.getCurrentEstatePlanningOpportunityId();
          if (!opp) {
            returnFlag = false;
          }
        } else if (currentUrlState.includes('health-insurance')) {
          const opp = this.authService.getCurrentHealthInsuranceOpportunityId();
          if (!opp) {
            returnFlag = false;
          }
        } else if (currentUrlState.includes('refinance-consolidation')) {
          const opp = this.authService.getCurrentOpportunityId();
          if (!opp) {
            returnFlag = false;
          }
        } else if (currentUrlState.includes('financial-goal')) {
          const opp = this.authService.getCurrentOpportunityId();
          if (!opp) {
            returnFlag = false;
          }
        } else {
          returnFlag = false;
        }
        if (returnFlag == false) {
          this.authService.showSnackBarMsg(
            'You did not have this Opportunity yet, please create one'
          );
          this.authService.gotoUrl('/');
        } else {
          return true;
        }
      }
    });
  }
}
